import { MODALS } from '~/shared/constants/modals';
import { closeResponsiveModal, openResponsiveModal } from '~/shared/ui/ResponsiveModals';
import { type PayoutTraderOrderV1SplitOrderResponse } from '~/generated/payoutBackend/model';
import { type SplitOrderProps } from '../SplitOrder';

export const openSplitOrderModal = (props: SplitOrderProps) => {
    openResponsiveModal({
        modalId: MODALS.PAYOUT_ORDER_SPLIT,
        modal: MODALS.PAYOUT_ORDER_SPLIT,
        title: 'Разделение ордера',
        innerProps: {
            ...props,
            onSuccess: (response: PayoutTraderOrderV1SplitOrderResponse) => {
                closeResponsiveModal(MODALS.PAYOUT_ORDER_SPLIT);
                props.onSuccess?.(response);
            },
            onCancel: () => {
                closeResponsiveModal(MODALS.PAYOUT_ORDER_SPLIT);
            },
        },
    });
};
